<template>
  <div>
    <form enctype="multipart/form-data" v-if="displayUploader">
      <span @drop.prevent.stop="fileChange($event.dataTransfer.files)" @dragover.prevent.stop="dragoverHandler($event)">
        <label class="file-label file-label--bigfield file-label--bigfield--striped is-border"
               :class="fileLabelStaus">
          <input class="file-input" type="file" name="file" @change="fileChange($event.target.files)"
                 :multiple="multiple" accept="image/*, .pdf"/>
          <div class="columns is-gapless w100"
               v-if="!isAvatar && !isSquareInput"
               :class="{'file-label-minHeight': isLarge}">

            <div
              class="column w100 has-text-centered is-padding is-margin-small file-label-dashMe columns is-gapless is-vcentered is-centered"
              :class="{'has-text-success': loading && !uploaded}">
              <div v-if="loading && !uploaded"
                   class="column is-narrow w100p">
                <span class="icon is-large"><i class="fas fa-spinner fa-spin fa-3x"></i></span>
              </div>
              <div v-else
                   class="column is-narrow w100p">
                <i class="fal fa-cloud-upload fa-3x"></i>
              </div>
              <div class="column is-narrow file-label columns is-vcentered is-gapless">
                <b class="is-uppercase is-underline">Sélectionner un fichier sur votre ordinateur</b>
                <span class="is-uppercase">&nbsp;OU faites glisser les fichiers dans cette zone</span>
              </div>
            </div>
          </div>
          <div v-else-if="!isAvatar && isSquareInput" class="columns is-gapless w100 file-label-minHeight">
            <div class="column w100 has-text-centered is-padding is-margin-small file-label-dashMe"
                 :class="{'has-text-success': loading && !uploaded}"
            >
              <div class="is-padding-bottom-small" v-if="loading && !uploaded">
                <i class="fas fa-spinner fa-spin fa-3x"></i>
              </div>
              <div class="is-padding-bottom-small" v-else>
                <i class="fal fa-cloud-upload fa-3x"></i>
              </div>
              <div class="file-label">
                <div class="w100">
                  <b class="is-uppercase is-underline">Sélectionner un fichier sur votre ordinateur</b>
                  <div class="is-uppercase is-margin-top-xsmall">OU faites glisser les fichiers dans cette zone</div>
                </div>
              </div>
            </div>
          </div>
          <span v-else>
            <div class="has-bg-light-darken-2 has-text-white is-clipped is-relative has-cursor-pointer"
                 :class="{'has-bg-dark-lighten-3': avatarHover}" style="width:126px; height:126px; line-height:126px"
                 @mouseover="avatarHover = true" @mouseleave="avatarHover = false">
              <img v-if="documents && documents[0]" :src="documents[0]|avatarBig">
              <i v-else class="is-absolutecenter fas fa-user-tie fa-6x"
                 :class="{'has-text-grey-light': avatarHover}"></i>
              <transition enter-active-class="animated fadeIn faster" leave-active-class="animated fadeOut faster">
                <i v-show="avatarHover" class="is-absolutecenter fas fa-camera-alt fa-3x"></i>
              </transition>
            </div>
          </span>
        </label>
      </span>
    </form>

    <div v-dragula="documents" drake="one" v-if="showList && canDrag">
      <uploaded-file-item class="is-border is-margin-top-xxsmall columns is-vcentered has-bg-white"
                          v-for="(document, index) in documents"
                          :index="index"
                          :key="document.fus_id"
                          :document="document"
                          :privacy="privacy"
                          :defaultNames="filteredDefaultNames"
                          :canDrag="canDrag"
                          @openPreview="openPreview"
                          @editDocument="editDocument"
                          @deleteDocument="deleteDocument"
      ></uploaded-file-item>
    </div>
    <div v-if="showList && !canDrag">
      <uploaded-file-item class="is-border is-margin-top-xxsmall columns is-vcentered has-bg-white"
                          v-for="(document, index) in documents"
                          :index="index"
                          :key="document.fus_id"
                          :document="document"
                          :privacy="privacy"
                          :defaultNames="filteredDefaultNames"
                          :canDrag="canDrag"
                          @openPreview="openPreview"
                          @editDocument="editDocument"
                          @deleteDocument="deleteDocument"
      ></uploaded-file-item>
    </div>
  </div>
</template>

<script>
  import UploadedFileItem from './UploadedFileItem'
  import { mapState } from 'vuex'
  import { setTimeout } from 'timers'

  require('formdata-polyfill')

  export default {
    name: 'UploadFile',
    data () {
      return {
        validDocument: null,
        files: null,
        loading: false,
        uploaded: false,
        uploadingNumber: 0,
        progressData: 0,
        selectedDocument: {},
        selectedIndex: null,
        avatarHover: false
      }
    },
    components: { UploadedFileItem },
    props: {
      customId: {
        type: String
      },
      documents: {
        type: Array,
        required: true
      },
      placeholder: {
        type: String
      },
      privacy: {
        type: Boolean,
        default: false
      },
      showList: {
        type: Boolean,
        default: true
      },
      multiple: {
        type: Boolean,
        default: true
      },
      isImage: {
        type: Boolean,
        default: false
      },
      circle: {
        type: Boolean,
        default: false
      },
      ratio: {
        type: Number
      },
      defaultNames: {
        type: Array,
        default: () => []
      },
      excludesNames: {
        type: Array
      },
      isLarge: {
        type: Boolean,
        default: false
      },
      isSquareInput: {
        type: Boolean,
        default: false
      },
      unique: {
        type: Boolean,
        default: false
      },
      canDrag: {
        type: Boolean,
        default: true
      },
      isAvatar: {
        type: Boolean
      },
      icon: String
    },
    computed: {
      ...mapState(['modal']),
      displayUploader () {
        if (this.unique) {
          if (!this.documents || !this.documents.length) return true
          else return false
        } else return true
      },
      filteredDefaultNames () {
        if (this.excludesNames && this.excludesNames.length) {
          return this.defaultNames.filter(x => !this.excludesNames.includes(x))
        } else return this.defaultNames
      },
      fileLabelStaus () {
        // is-inProgress
        if (this.validDocument) {
          return 'is-validDrop'
        } else if (this.validDocument === false) {
          return 'is-wrongDrop'
        } else return ''
      }
    },
    watch: {
      modal ({ mode, params, results }) {
        if (results) {
          if (mode === 'DOCUMENT_EDIT' && params.id === this.customId) {
            this.upload(results, params)
          }
        }
      }
    },
    methods: {
      fileChange (files) {
        for (let i = 0; i < files.length; i++) {
          let file = files[i]
          if (file.type !== 'image/png' && file.type !== 'application/pdf' && file.type !== 'image/jpeg') this.validDocument = false
        }
        if (this.validDocument !== false) {
          this.loading = false
          this.uploaded = false
          for (let i = 0; i < files.length; i++) {
            let file = files[i]
            this.files.append('file[]', file, file.name)
          }
          this.upload()
        } else {
          setTimeout(() => {
            this.validDocument = null
          }, 2000)
        }
      },
      async upload (e = null, params = null) {
        let files
        if (e !== null) files = e
        else files = this.files
        this.uploadingNumber = files.length
        this.loading = true
        let config = {
          onUploadProgress: progressEvent => {
            this.progressData = Math.floor((progressEvent.loaded * 100) / progressEvent.total)
          }
        }
        try {
          let res = await this.$fus.post({ data: files, config })
          let hostedFiles = res.data.slice()
          let filename
          hostedFiles = hostedFiles.map(x => {
            filename = x.filename
            return {
              fus_id: x.id,
              cloudinary_id: x.cloudinary_id,
              cloudinary_version: x.cloudinary_version,
              path: x.path,
              filename: x.filename,
              display: x.display || true
            }
          })
          this.loading = false
          this.uploaded = true
          this.validDocument = true
          if (files.cropped) {
            if (filename === 'Brochure du programme.jpg' || filename === 'Dossier de réservation.jpg') {
              hostedFiles = hostedFiles.map(x => {
                return {
                  fus_id: x.id,
                  cloudinary_id: x.cloudinary_id,
                  cloudinary_version: x.cloudinary_version,
                  path: x.path,
                  filename: x.filename.split('.').slice(0, -1).join('.'),
                  display: x.display || true
                }
              })
              hostedFiles.filename = filename.split('.').slice(0, -1).join('.')
            }
            hostedFiles.cropped = true
            if (params.index) {
              hostedFiles.croppedIndex = params.index
            } else {
              hostedFiles.croppedIndex = this.selectedIndex
            }
          }
          this.$emit('upload', hostedFiles)
          this.$nextTick(() => {
            this.validDocument = null
            this.reset()
          })
        } catch (e) {
          this.loading = false
        }
      },
      reset () {
        delete this.files
        this.files = new FormData()
        this.loading = false
        this.uploaded = false
      },
      deleteDocument ({ document }) {
        this.$emit('deleteDocuments', document)
        if (this.documents.length === 0) {
          this.$emit('upload', this.documents)
        }
      },
      dragoverHandler (ev) {
        ev.preventDefault()
      },
      editDocument ({ selectedDocument, index }) {
        let params = {
          source: selectedDocument,
          index,
          ratio: this.ratio,
          circle: this.circle,
          id: this.customId
        }
        this.selectedDocument = selectedDocument
        this.selectedIndex = index
        this.$store.commit('setModal', { mode: 'DOCUMENT_EDIT', params })
      },
      openPreview (selectedDocument) {
        let params = {
          source: selectedDocument
        }
        this.$store.commit('setModal', { mode: 'DOCUMENT_PREVIEW', params })
        // bus.$emit(EVENTS.OPEN_MODAL, {mode: 'DOCUMENT_PREVIEW', params})
      }
    },
    created () {
      this.files = new FormData()
    },
    mounted () {
      // bus.$on(EVENTS.SUBMIT_MODAL, ({mode, params, results}) => {
      //   if (mode === 'DOCUMENT_EDIT' && params.id === this.customId) {
      //     this.upload(results)
      //   }
      // })
    },
    destroyed () {
      // bus.$off(EVENTS.SUBMIT_MODAL)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/utils/UploadFile.vue